// frontend/shared-ui/src/components/Button.jsx
import React from "react";

export const Button = ({
  children,
  variant = "primary", // "primary" | "secondary" | "ghost" | "danger" | "bare"
  size = "medium", // "small" | "medium" | "large"
  onClick,
  disabled = false,
  type = "button",
  className = "",
  ...rest
}) => {
  // "bare" = caller supplies all styling via className
  const classes =
    variant === "bare"
      ? className
      : `btn btn-${variant} btn-${size} ${className}`.trim();

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};
